export default __webpack_public_path__ + "static/media/tradetransformers.63c72336.svg";